/**
 * Copyright (c) 2026 Accunai India Services Pvt. Ltd. All rights reserved.
 *
 * PROPRIETARY AND CONFIDENTIAL
 *
 * This file is part of proprietary software owned by Accunai India Services Pvt. Ltd.
 * Unauthorized copying, distribution, modification, or use of this file,
 * in whole or in part, via any medium, is strictly prohibited without
 * prior written permission from Accunai India Services Pvt. Ltd.
 *
 * Generated with GitHub Copilot Business/Enterprise.
 * Reviewed and approved by: AI-assisted / 2026-07-03
 */

import { AxiosError } from "axios";
import { AppErrorDetails } from "./types";

interface ErrorResponseBody {
  message?: string;
  correlationId?: string;
}

const RATE_LIMIT_STATUS = 429;
const AUTH_FAILURE_STATUSES = [401, 403] as const;
const AUTH_RELATED_STATUSES = [400, ...AUTH_FAILURE_STATUSES];

export const isAuthFailureStatusCode = (statusCode?: number): boolean => {
  if (statusCode === undefined) {
    return false;
  }

  return AUTH_FAILURE_STATUSES.includes(statusCode as 401 | 403);
};

export const normalizeApiError = (
  error: unknown,
  fallbackMessage: string,
  authFailureMessage: string
): AppErrorDetails => {
  const axiosError = error as AxiosError<ErrorResponseBody>;
  const statusCode = axiosError.response?.status;
  const responseMessage = axiosError.response?.data?.message;
  const headerCorrelationId = axiosError.response?.headers?.["x-correlation-id"];
  const bodyCorrelationId = axiosError.response?.data?.correlationId;

  if (statusCode === RATE_LIMIT_STATUS && responseMessage) {
    return {
      message: responseMessage,
      statusCode,
      correlationId: bodyCorrelationId || headerCorrelationId,
    };
  }

  if (statusCode && AUTH_RELATED_STATUSES.includes(statusCode)) {
    return {
      message: authFailureMessage,
      statusCode,
      correlationId: bodyCorrelationId || headerCorrelationId,
    };
  }

  if (responseMessage) {
    return {
      message: responseMessage,
      statusCode,
      correlationId: bodyCorrelationId || headerCorrelationId,
    };
  }

  return {
    message: fallbackMessage,
    statusCode,
    correlationId: bodyCorrelationId || headerCorrelationId,
  };
};
